import React, { useState } from "react";
import { useSelector } from "react-redux";
import { format } from "date-fns";
import CommonFilterStructure from "../../components/common-components/CommonFilterStructure";

const SubscriptionTableFIltrs = ({
  allSubsTbData,
  allSubsPlanStatsData,
  allMaleFemaleBurification,
  decryptedText,
  subsTbFilters,
  setSubsTbFilters,
  onClickSearch,
  searchFilterApplied,
  onClickReset,
}) => {
  const { loading, oneDayPlansLoading } = useSelector((state) => state.api);

  const [activeDateRanges, setActiveDateRanges] = useState({
    subsStart: false,
    subsCreate: false,
    subsExpiring: false,
  });
  const initialRangeStates = {
    subsCreate: [
      {
        startDate: null,
        endDate: null,
        key: "subsCreate",
      },
    ],
    subsStart: [
      {
        startDate: null,
        endDate: null,
        key: "subsStart",
      },
    ],
    subsExpiring: [
      {
        startDate: null,
        endDate: null,
        key: "subsExpiring",
      },
    ],
  };
  const [rangeStates, setRangeStates] = useState(initialRangeStates);

  const handleDateRangeChange = (item, rangeKey) => {
    const startDate = item[rangeKey].startDate;
    const endDate = item[rangeKey].endDate;

    if (startDate && endDate) {
      setRangeStates({
        ...rangeStates,
        [rangeKey]: [item[rangeKey]],
      });

      const formattedStartDate = format(startDate, "yyyy-MM-dd");
      const formattedEndDate = format(endDate, "yyyy-MM-dd");

      setSubsTbFilters({
        ...subsTbFilters,
        [`${rangeKey}From`]: formattedStartDate,
        [`${rangeKey}To`]: formattedEndDate,
      });
    }
  };

  const clearDateRanger = (rangeKey) => {
    setRangeStates({
      ...rangeStates,
      [rangeKey]: initialRangeStates[rangeKey],
    });

    setSubsTbFilters({
      ...subsTbFilters,
      [`${rangeKey}From`]: "",
      [`${rangeKey}To`]: "",
    });
  };

  return (
    <CommonFilterStructure
      from={"subscriptions"}
      decryptedText={decryptedText}
      setFilters={setSubsTbFilters}
      filters={subsTbFilters}
      searchFilterApplied={searchFilterApplied}
      onClickSearch={onClickSearch}
      allSubsTbData={allSubsTbData}
      allSubsPlanStatsData={allSubsPlanStatsData}
      allMaleFemaleBurification={allMaleFemaleBurification}
      activeDateRanges={activeDateRanges}
      setActiveDateRanges={setActiveDateRanges}
      onClickReset={onClickReset}
      handleDateRangeChange={handleDateRangeChange}
      rangeStates={rangeStates}
      clearDateRanger={clearDateRanger}
      isLoading={loading || oneDayPlansLoading}
    />
  );
};

export default SubscriptionTableFIltrs;
